import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityLock } from "../../entity/EntityLock";

export class DtoLocksGetRes extends EntityLock {
  public items: EntityLock[]  = [];
}
